module.exports = __webpack_public_path__ + "static/img/penny_pictgrid18_960x874.8a4eb2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/penny_pictgrid18_960x874.jpg
// module id = 05lh
// module chunks = 0